(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function () {

  //travel trailer data = model=1&length=30&floorplan=30rb&decor=cognac_maple_macadamia&options=281,635&customer=Testing-User&zip=46659&email=testing@user.com
  //touring coach data = model=1&color=id&floorplan=slug&decor=slug&options=id&customer=Testing-User&zip=46659&email=testing@user.com
  var configData = {};

  jQuery('.model-card').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var redirect = jQuery(this).find('a.btn-begin').attr('href');

    var productId = jQuery(this).attr('prod-id'),
        productName = jQuery(this).attr('prod-name');
    productImg = jQuery(this).find('.pl-gbImg').find('img').attr('src');

    configData.model = productId;
    configData.modelName = productName;
    configData.productImage = productImg;
    configData.configType = 'tc';
    configData.firstName = '';
    configData.lastName = '';
    configData.zip = '45334';

    sessionStorage.setItem('configData', JSON.stringify(configData));
    localStorage.setItem('configData', JSON.stringify(configData));

    var retUrl = redirect + buildURLParams();
    var seenForm = getCookie('tc_form');

    if (seenForm) {
      window.location.href = retUrl;
    } else {
      $('.pl-form-modal').fadeIn();
      $('.pl-form-modal').attr('return-url', retUrl);
    }
  });
});

},{}]},{},[1]);
